import { render, staticRenderFns } from "./CopyRow.vue?vue&type=template&id=56ff59a8&scoped=true"
import script from "./CopyRow.vue?vue&type=script&lang=js"
export * from "./CopyRow.vue?vue&type=script&lang=js"
import style0 from "./CopyRow.vue?vue&type=style&index=0&id=56ff59a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff59a8",
  null
  
)

export default component.exports